import { ReactNode } from 'react'

import { useRegion } from 'components/app-shell/context/RegionContext'

export type AuthLocale = 'ar' | 'en'

const TAGLINE: Record<AuthLocale, string> = {
  ar: 'منصة التقارير اليومية لمشاريعك.',
  en: 'The daily reporting platform for your projects.',
}

const SKIP_LABEL: Record<AuthLocale, string> = {
  ar: 'تخطي إلى المحتوى',
  en: 'Skip to content',
}

/** Auth pages render their body through this render-prop so the current locale reaches
    them on every toggle (a plain children node, captured before AuthShell re-renders, would not). */
export const AuthShell = ({ children }: { children: (locale: AuthLocale) => ReactNode }) => {
  const { locale, setLocale } = useRegion()
  const dir = locale === 'ar' ? 'rtl' : 'ltr'

  return (
    <div className="auth" dir={dir} lang={locale}>
      <a className="skip-link" href="#auth-main">
        {SKIP_LABEL[locale]}
      </a>
      <div className="auth__lang" role="group" aria-label={locale === 'ar' ? 'اللغة' : 'Language'}>
        <button
          type="button"
          className={locale === 'en' ? 'auth__lang-btn is-active' : 'auth__lang-btn'}
          aria-label="Switch to English"
          onClick={() => setLocale('en')}
        >
          EN
        </button>
        <button
          type="button"
          className={locale === 'ar' ? 'auth__lang-btn is-active' : 'auth__lang-btn'}
          lang="ar"
          aria-label={locale === 'en' ? 'Change language to Arabic' : 'التبديل إلى الإنجليزية'}
          onClick={() => setLocale('ar')}
        >
          ع
        </button>
      </div>
      <main id="auth-main" className="auth__main" tabIndex={-1}>
        <div className="auth__card">{children(locale)}</div>
      </main>
      <aside className="auth__aside">
        <div className="auth__aside-inner">
          <span className="auth__aside-mark" aria-hidden="true">
            JoPath
          </span>
          <p className="auth__aside-tagline">{TAGLINE[locale]}</p>
        </div>
      </aside>
    </div>
  )
}
